import React from 'react'
import { Row, Col, Space } from 'antd'

import { GotoSocial } from 'core/util/common'

import logoFooter from 'assets/images/svg/logo2.svg'
import imgFooter from 'assets/images/png/student_comp-02.png'

import { ReactComponent as Twitter } from 'assets/images/svg/icon-twitter.svg'
import { ReactComponent as Facebook } from 'assets/images/svg/Icon awesome-facebook.svg'
import { ReactComponent as Tiktok } from 'assets/images/svg/icon-tiktok.svg'

import {
  CustomFooter,
  CardFooter,
  TitleContact,
  TextContact,
} from './footer.style'

const FooterComponent = () => {
  return (
    <CustomFooter>
      <CardFooter>
        <Row className='logo'>
          <Col span={16}>
            <img
            loading="lazy"
              src={logoFooter}
              alt='logo footer'
              style={{ width: '100%', maxWidth: '220px' }}
            />

            <TitleContact>
              ต้องการสอบถาม
              <br /> ข้อมูลเพิ่มเติมใช่ไหมคะ ?
            </TitleContact>
            <TextContact size='24'>
              น้อง ๆ สามารถติดหน่วยงานที่เกี่ยวข้องได้โดยตรงเลยค่ะ
              <br /> ในแต่ละ Topic เราจะมีข้อมูลติดต่อด้านล่าง
            </TextContact>
          </Col>

          <Col span={8}>
            <Row align='top' className='row-img-phone'>
              <Col span={24}>
                <img
                loading="lazy"
                  src={imgFooter}
                  alt='img footer'
                  style={{ width: '100%', maxWidth: '280px' }}
                />
              </Col>
            </Row>
            <Row align='middle' justify='center' className='left'>
              <Col span={24}>
                <TextContact>
                  ติดตามข่าวสาร
                  <br />
                  จากทางมหาวิทยาลัย
                </TextContact>
                <Space size='large'>
                  <Facebook
                    className='img facebook'
                    onClick={() => GotoSocial('fb')}
                  />
                  <Tiktok
                    className='img tiktok'
                    onClick={() => GotoSocial('tt')}
                  />
                  <Twitter
                    className='img twitter'
                    onClick={() => GotoSocial('tw')}
                  />
                 
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardFooter>
    </CustomFooter>
  )
}

export default FooterComponent
